// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor__2R_wL","host":"Anchor_host__3fU83","title":"Anchor_title__2nmSo","description":"Anchor_description__10kgM"};